import "../scss/etd21.scss";
// import 'jquery';
// import 'bootstrap';

( function($) {

	$('.drop-down-menu').on('click', function (e) {


		$(this).toggleClass('x');

		let menu = $( "#drop-down-menu-content" );
		if( menu.children().length === 0 ) {
			$( "#drop-down-menu-content").append( '<div class="search_block border-bottom mb-2"><form action="/suche" class="search_form" method="get">\n' +
				'<input id="searchtext" itemprop="query-input" type="text" placeholder="SUCHE" name="q">' +
				'<button class="top-search ml-2 mt-2"></button></form></div>' );
			$( "#footer .services").clone().appendTo( "#drop-down-menu-content" );
			$( "#footer-menu").clone().appendTo( "#drop-down-menu-content" );
		}

		if ( menu.css('visibility') == 'hidden' )
    		menu.css('visibility','visible');
  		else
    		menu.css('visibility','hidden');

	});
})(jQuery);


(function ($) {

	$('.lazy').lazy({
	    _kommentare_loader: function _kommentare_loader(e) {
		  	$.ajax({
		        type: 'GET',
		        url: _ETD_COMMENTS_API_BASE + '/api/kommentare/' + _ETD_COMMENTS_ITEM + '/' + _ETD_COMMENTS_ITEM_HASH,
		        cache: false,
				headers 	: {'Authorization': 'Bearer ' + $.cookie( _ETD_COMMENTS_TOKEN_COOKIE_NAME ) },
		        success: function success(response, statusText, jqxhr) {

		          $('#kommentare-form').html(response.login_form);
		          $('#kommentare-content').html(response.data);
		          document.etd_commenter_login = response.commenter_login_status;
		        },
		        error: function error(jqxhr, statusText, err) {
		          console.log(statusText);
		          console.log(err);
		        }
			});
	    },

		// beforeLoad: function(element) {
  //           console.log( element);
  //       },

		_ad21_rect_1: function _ad21_rect_1 ( e ) {
			e.append( _etd21Display01 );
		},

		_ad21_rect_2: function _ad21_rect_2 ( e ) {
			e.append( _etd21InArticle02 );
		},

		_ad21_rect_3: function _ad21_rect_3 ( e ) {
			e.append( _etd21InArticle03 );
		},
		_ad21_rect_4: function _ad21_rect_4 ( e ) {
			e.append( _etd21InArticle04 );
		},
		_ad21_rect_5: function _ad21_rect_5 ( e ) {
			e.append( _etd21InArticle05 );
		},
		_ad21_rect_6: function _ad21_rect_6 ( e ) {
			e.append( _etd21InArticle06 );
		},


		_kommentare_anzahl: function (e) {
			$.ajax({
		        type: 'GET',
		        url: _ETD_COMMENTS_API_BASE + '/api/kommentare/comments/count/' + _ETD_COMMENTS_ITEM + '/' + _ETD_COMMENTS_ITEM_HASH,
		        cache: false,
		        success: function success(response, statusText, jqxhr) {
		        	$('.comment-count').html(response);
		        },
		        error: function error(jqxhr, statusText, err) {
		          console.log(statusText);
		          console.log(err);
		        }
			});
		},
		// onError: function(element) {
  //       	console.log('error loading ' + element.data('src'));
  //   	}

  	});

})(jQuery);




(function($){

	$('#kommentare').on('click', '#comments-sort', function(e) {

		var sort = $(this).data( 'sort' );
		$.ajax({
	        type: 'GET',
	        url: _ETD_COMMENTS_API_BASE + '/api/kommentare/' + _ETD_COMMENTS_ITEM + '/' + _ETD_COMMENTS_ITEM_HASH + '/' + sort,
	        cache: false,
			headers 	: {'Authorization': 'Bearer ' + $.cookie( _ETD_COMMENTS_TOKEN_COOKIE_NAME ) },
	        success: function success(response, statusText, jqxhr) {

	          $('#kommentare-form').html(response.login_form);
	          $('#kommentare-content').html(response.data);
	          document.etd_commenter_login = response.commenter_login_status;
	        },
	        error: function error(jqxhr, statusText, err) {
	          console.log(statusText);
	          console.log(err);
	        }
		});
		e.preventDefault();
	});



	$('#kommentare').on('submit', '#comments-user-login', function(e) {
		var email = $('#email', this).val();
        var password = $('#password', this).val();
        var token = "";

    	$.ajax({
            type        : 'POST',
            url         : _ETD_COMMENTS_API_BASE + '/api/login/' + _ETD_COMMENTS_ITEM + '/' + _ETD_COMMENTS_ITEM_HASH,
            cache       : false,
            data        : {'email':email, 'password':password},

            success		: function(response, statusText, jqxhr) {

                if(response.status_code == 200) {

                    $.cookie(_ETD_COMMENTS_TOKEN_COOKIE_NAME, response.token, { expires: 7, path: '/' });

                    $('#kommentare-form').html(response.data);
                    document.etd_commenter_login = true;

                } else {
                	console.log( response );
                    $('#login-messages').addClass('alert alert-danger').html(response.data);
                }

            },
            error		: function (jqxhr, statusText, err) {
            	console.log( statusText );
            	console.log( err );
            }
		});

        e.preventDefault();
	});


    $('#kommentare').on('click', '#comments-user-logout', function(e) {

        e.preventDefault();



        var url = $('#comments-user-logout').attr('href');

        $.ajax({
            type        : 'POST',
            url         : url,
            cache       : false,
            headers     : {'Authorization': 'Bearer ' + $.cookie( _ETD_COMMENTS_TOKEN_COOKIE_NAME ) },

            success     : function(response, statusText, jqxhr) {

                if(response.status_code == 200) {

                    $.cookie(_ETD_COMMENTS_TOKEN_COOKIE_NAME, null, { path: '/' });
                    document.etd_commenter_login = false;
                    $('#kommentare-form').html(response.data);

                } else {
                    $('#messages', this).addClass('alert alert-danger').text(response.data);
                }

            },
            error       : function (jqxhr, statusText, err) {
                console.log( statusText );
                console.log( err );
            }
        });
    });


    $('#kommentare').on('submit', '#comments-new-comment', function(e) {

        var form = $('#comments-new-comment');

        $.ajax({
            type        : 'POST',
            url         : _ETD_COMMENTS_API_BASE + '/api/kommentare/' +  _ETD_COMMENTS_ITEM + '/' + _ETD_COMMENTS_ITEM_HASH,
            cache       : false,
            data        : form.serialize(),
            headers     : {'Authorization': 'Bearer ' + $.cookie( _ETD_COMMENTS_TOKEN_COOKIE_NAME ) },

            success     : function(response, statusText, jqxhr) {

                if(response.success) {
                    $('#kommentare-form').html(response.data);
                } else {
                    $('#messages', this).addClass('alert alert-danger').text(response.data);
                }
            },
            error       : function (jqxhr, statusText, err) {
                console.log( statusText );
                console.log( err );
            }
        });

        e.preventDefault();
    });


	$('#kommentare').on('click', '.reply', function (e){
		var form = $(this).parent().siblings('.comment-reply');

		if( form.text().length < 100 ) {
			if( document.etd_commenter_login ) {
				form.html(
'<form class="comment-reply-form" method="POST" action="#"><div class="form-group"><label for="message">Geben Sie hier Ihren Kommentar ein:</label><textarea required class="form-control" name="message" rows="6"></textarea></div><button type="submit" class="btn btn-sm btn-outline-success text-uppercase">Senden</button></form>'
				)
			} else {
				form.hide().html(
'<div class="card-text text-info">Bitte anmelden, um Kommentare zu schreiben.</div>'
				);
			}
		}

		form.is(':visible') ? form.hide() : form.show();

		e.preventDefault();
	});

	$('#kommentare').on('submit', '.comment-reply-form', function(e) {

		var form = $(this);
    	var parent_comment_id = form.parent().data('id');

        $.ajax({
            type        : 'POST',
            url         : _ETD_COMMENTS_API_BASE + '/api/kommentare/reply/' + parent_comment_id + '/' +  _ETD_COMMENTS_ITEM + '/' + _ETD_COMMENTS_ITEM_HASH,
            cache       : false,
            data        : form.serialize(),
            headers     : {'Authorization': 'Bearer ' + $.cookie( _ETD_COMMENTS_TOKEN_COOKIE_NAME ) },

            success     : function(response, statusText, jqxhr) {

                if(response.success) {
                    form.html(response.data);
                } else {
                    $('#messages', this).addClass('alert alert-danger').text(response.data);
                }

            },
            error       : function (jqxhr, statusText, err) {
                console.log( statusText );
                console.log( err );
            }
        });
        e.preventDefault();
    });


	$('#kommentare').on('click', '.load-more-comments', function( e ){
		var $this = $(this);
		var url = $this.attr('href');

		$.ajax({
	        type: 'GET',
	        url: url,
	        cache: false,
			headers 	: {'Authorization': 'Bearer ' + $.cookie( _ETD_COMMENTS_TOKEN_COOKIE_NAME ) },
	        success: function success(response, statusText, jqxhr) {
  	          $('#kommentare-content').append(response.data);
	          document.etd_commenter_login = response.commenter_login_status;

	          $this.hide();
	        },
	        error: function error(jqxhr, statusText, err) {
	          console.log(statusText);
	          console.log(err);
	        }
		});

		e.preventDefault();
	});

	$('#kommentare').on('click', '.votes', function( e ){

		var $this = $(this);
		var action = $(this).data('action');
		var comment_id = $(this).parent().data('id');

		var form = $this.parent().siblings('.comment-reply');
		if( ! document.etd_commenter_login ) {

			form.html(
'<div class="card-text text-info">Bitte melden Sie sich an, um Bewertungen abzugeben.</div>'
			);

			form.show();

			return;
		}
		form.hide();

        $.ajax({
            type        : 'POST',
            url         : _ETD_COMMENTS_API_BASE + '/api/kommentare/vote/'+ action + '/' + comment_id + '/' +  _ETD_COMMENTS_ITEM + '/' + _ETD_COMMENTS_ITEM_HASH,
            cache       : false,
            headers     : {'Authorization': 'Bearer ' + $.cookie( _ETD_COMMENTS_TOKEN_COOKIE_NAME ) },

            success     : function(response, statusText, jqxhr) {

                if(response.success) {
                	$('span[data-action="upvote"]>span', $this.parent()).html(response.data['upvote']);
                    $('span[data-action="downvote"]>span', $this.parent()).html(response.data['downvote']);
                } else {
                    $('#messages', $this).addClass('alert alert-danger').text(response.data);
                }
            },
            error       : function (jqxhr, statusText, err) {
                console.log( statusText );
                console.log( err );
            }
        });
	});
})(jQuery);

if (new URLSearchParams(window.location.search).has('seite_zuruecksetzen')) {
    $.each(document.cookie.split(/; */), function()  {
        var splitCookie = this.split('=');
        $.removeCookie(splitCookie[0]);
        $.removeCookie(splitCookie[0], { path: '/', domain: '.epochtimes.de' });
    });
    location.href = location.href.replace('seite_zuruecksetzen=true','');
}

function isVisible(elem) {
	if (!(elem instanceof Element)) throw Error('DomUtil: elem is not an element.');
	const style = getComputedStyle(elem);
	if (style.display === 'none') return false;
	if (style.visibility !== 'visible') return false;
	if (style.opacity < 0.1) return false;
	if (elem.offsetWidth + elem.offsetHeight + elem.getBoundingClientRect().height +
		elem.getBoundingClientRect().width === 0) {
		return false;
	}
	const elemCenter   = {
		x: elem.getBoundingClientRect().left + elem.offsetWidth / 2,
		y: elem.getBoundingClientRect().top + elem.offsetHeight / 2
	};
	if (elemCenter.x < 0) return false;
	if (elemCenter.x > (document.documentElement.clientWidth || window.innerWidth)) return false;
	if (elemCenter.y < 0) return false;
	if (elemCenter.y > (document.documentElement.clientHeight || window.innerHeight)) return false;
	let pointContainer = document.elementFromPoint(elemCenter.x, elemCenter.y);
	do {
		if (pointContainer === elem) return true;
	} while (pointContainer = pointContainer.parentNode);
	return false;
}

function sleep(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}